import { TMainVisualFormData } from 'src/@types';
import { IMainVisual } from 'src/models';
import { TPageParams } from 'src/models/extensions/withPagination';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/visual';

const convertDataInfoToFormData = (data: TMainVisualFormData) => {
  const formData = new FormData();
  // 수정일 경우 visualSid 추가
  if (data.visualSid) {
    formData.append('visualSid', data.visualSid.toString());
  }

  // 이미지 파일 추가 (detailImage는 배열로 가정)
  if (data.bgPath && data.bgPath.length > 0) {
    data.bgPath.forEach((file, index) => {
      // formData.append(`bgPath[${index}]`, file);
      formData.append(`bgPath`, file);
    });
  }
  if (data.deleteFilesPath && data.deleteFilesPath.length > 0) {
    data.deleteFilesPath.forEach((file, index) => {
      formData.append(`deleteFilesPath`, file);
    });
  }

  // 새로 업로드된 파일 추가
  if (data.files && data.files.length > 0) {
    data.files.forEach((file, index) => {
      // formData.append(`files[${index}]`, file); // 새로 업로드된 파일
      formData.append(`files`, file); // 새로 업로드된 파일
    });
  }

  // 나머지 텍스트 데이터 추가
  // formData.append('useYn', data.useYn ? 'Y' : 'N');
  if (data.mode === 'data') {
    formData.append('mainText', JSON.stringify(data.mainText) || '');
    formData.append('subText', JSON.stringify(data.subText) || '');
  } else {
    formData.append('editorContent', JSON.stringify(data.editorContent) || '');
  }

  return formData;
};

/**
 * 메인 비주얼 목록 조회
 */
export const getMainvisual = async (pageParams: TPageParams) => {
  try {
    const url = SUB_URL + objectToQueryString(pageParams);
    const response = await instance.get<TApiResponseData<IMainVisual[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 상세 조회
 */
export const getDetail = async (visualSid: number) => {
  try {
    const url = `${SUB_URL}/${visualSid}`;
    const response = await instance.get<TApiResponseData<IMainVisual>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 등록
 */
export const post = async (data: TMainVisualFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IMainVisual>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 수정
 */
export const put = async (data: TMainVisualFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}/${data.visualSid}`;

    const response = await instance.put<TApiResponseData<IMainVisual>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 삭제
 */
export const remove = async (visualSid: number) => {
  try {
    const url = `${SUB_URL}/${visualSid}`;
    const response = await instance.delete<TApiResponseData<IMainVisual>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
